function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Pagination from "@/admin/Pieces/Pagination";
export default {
  name: 'DataConnectorFeeds',
  components: {
    Pagination: Pagination
  },
  data: function data() {
    return {
      loading: false,
      pagination: {
        current_page: 1,
        per_page: 15,
        total: 0
      },
      feeds: [],
      adding_new: false,
      new_feed: {
        title: ''
      },
      saving: true,
      all_loaded: false
    };
  },
  methods: {
    fetch: function fetch() {
      var _this = this;
      this.loading = true;
      this.$get('feeds', {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page
      }).then(function (response) {
        _this.feeds = response.feeds.data;
        _this.pagination.total = response.feeds.total;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.loading = false;
        _this.all_loaded = true;
      });
    },
    addFeed: function addFeed() {
      var _this2 = this;
      this.saving = true;
      this.$post('feeds', _objectSpread({}, this.new_feed)).then(function (response) {
        _this2.$notify.success(response.message);
        _this2.$router.push({
          name: 'edit_connector',
          params: {
            feed_id: response.feed.id
          }
        });
      })["catch"](function (errors) {
        _this2.$handleError(errors);
      }).always(function () {
        _this2.saving = false;
      });
    },
    deleteConnector: function deleteConnector(id) {
      var _this3 = this;
      this.$del('feeds/' + id).then(function (response) {
        _this3.$notify.success(response.message);
        _this3.fetch();
      })["catch"](function (errors) {
        _this3.$handleError(errors);
      }).always(function () {});
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
};